(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-product-card"] && !Shopify.designMode) return;
  try {
    async function applyArticlePromo(element) {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: element.dataset.articlePromoCode })
    });
    if (!response.ok) throw new Error('Discount update failed');
  }

  function articlePromoError(element) {
    const card = element.closest('product-card');
    const error = card?.querySelector('.article-product-offer__error');
    if (error) error.hidden = false;
    element.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.article-product-offer__form');
    if (!form) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');
    try {
      await applyArticlePromo(form);
      HTMLFormElement.prototype.submit.call(form);
    } catch {
      articlePromoError(form);
    }
  });

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a.product-card__media, a.product-title');
    const card = link?.closest('product-card[data-article-promo-code]');
    if (!card || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      await applyArticlePromo(card);
      window.location.assign(link.href);
    } catch {
      articlePromoError(link);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    function explicitCartDiscountField(target) {
    return target instanceof Element ? target.closest('cart-discount-field[data-explicit-apply]') : null;
  }

  function showCartDiscountError(field) {
    const banner = field.closest('.cart-discount').querySelector('cart-discount-banner');
    const input = field.querySelector('input:not([type="hidden"])');
    banner.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', banner.id);
  }

  async function applyExplicitCartDiscount(field) {
    const input = field.querySelector('input:not([type="hidden"])');
    const button = field.querySelector('[data-cart-discount-apply]');
    const banner = field.closest('.cart-discount').querySelector('cart-discount-banner');
    if (button.disabled || field.getAttribute('aria-busy') === 'true') return;
    input.value = input.value.trim();
    banner.hidden = true;
    input.removeAttribute('aria-invalid');
    if (!input.value) {
      showCartDiscountError(field);
      input.focus();
      return;
    }
    const buttonLabel = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.applyingLabel;
    try {
      await customElements.whenDefined('cart-discount-field');
      await field.toggleDiscount({ currentTarget: field, target: input });
      if (!banner.hidden) showCartDiscountError(field);
    } catch {
      field.setAttribute('aria-busy', 'false');
      showCartDiscountError(field);
    } finally {
      button.disabled = false;
      button.textContent = buttonLabel;
    }
  }

  // Keep typing separate from applying; the hidden input retains only saved codes.
  document.addEventListener('input', (event) => {
    const field = explicitCartDiscountField(event.target);
    if (!field || !event.target.matches('input:not([type="hidden"])')) return;
    event.stopPropagation();
    field.closest('.cart-discount').querySelector('cart-discount-banner').hidden = true;
    event.target.removeAttribute('aria-invalid');
  }, true);

  document.addEventListener('change', (event) => {
    const field = explicitCartDiscountField(event.target);
    if (field && event.target.matches('input:not([type="hidden"])')) event.stopPropagation();
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-cart-discount-apply]') : null;
    const field = explicitCartDiscountField(button);
    if (!field) return;
    event.preventDefault();
    applyExplicitCartDiscount(field);
  });

  document.addEventListener('keydown', (event) => {
    const field = explicitCartDiscountField(event.target);
    if (!field || event.key !== 'Enter' || !event.target.matches('input:not([type="hidden"])')) return;
    event.preventDefault();
    event.stopPropagation();
    applyExplicitCartDiscount(field);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
